"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePriceRating = void 0;
const core_1 = require("@angular/core");
const enums_1 = require("../../../@shared-types/api/mobile-seller/enums");
let MobilePriceRating = class MobilePriceRating {
    constructor() {
        this.fillClass = '';
        this.ratingTranslation = '';
    }
    ngOnChanges() {
        switch (this.rating) {
            case enums_1.MobileSellerAPIAdPriceRating.VERY_GOOD_PRICE:
                this.ratingTranslation = 'Sehr guter Preis';
                this.fillClass = 'five';
                break;
            case enums_1.MobileSellerAPIAdPriceRating.GOOD_PRICE:
                this.ratingTranslation = 'Guter Preis';
                this.fillClass = 'four';
                break;
            case enums_1.MobileSellerAPIAdPriceRating.REASONABLE_PRICE:
                this.ratingTranslation = 'Fairer Preis';
                this.fillClass = 'three';
                break;
            case enums_1.MobileSellerAPIAdPriceRating.INCREASED_PRICE:
                this.ratingTranslation = 'Erhöhter Preis';
                this.fillClass = 'two';
                break;
            case enums_1.MobileSellerAPIAdPriceRating.HIGH_PRICE:
                this.ratingTranslation = 'Hoher Preis';
                this.fillClass = 'one';
                break;
            default:
                this.ratingTranslation = 'Keine Preisbewertung';
                this.fillClass = '';
                break;
        }
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof enums_1.MobileSellerAPIAdPriceRating !== "undefined" && enums_1.MobileSellerAPIAdPriceRating) === "function" ? _a : Object)
], MobilePriceRating.prototype, "rating", void 0);
MobilePriceRating = __decorate([
    (0, core_1.Component)({
        selector: 'mobile-price-rating',
        template: /* html */ `
    <div class="price-rating" [ngClass]="fillClass">
      <div class="price-rating-bar">
        <div class="price-rating-fill"></div>
      </div>
      <span class="price-rating-text">{{ ratingTranslation }}</span>
    </div>
  `,
    })
], MobilePriceRating);
exports.MobilePriceRating = MobilePriceRating;
